import { Text } from '@zillow/constellation-10';
import { getMessageTimestampText } from '../../utils';

type TimestampProps = {
  messageDateMs: string;
  color?: string;
};

export default function Timestamp({ color = 'text.subtle', messageDateMs }: TimestampProps): JSX.Element {
  const timestampText = getMessageTimestampText(messageDateMs || '');

  return (
    <Text
      data-testid="timestamp"
      textStyle="body-xs"
      css={{
        color,
        textWrap: 'nowrap',
      }}
    >
      {timestampText}
    </Text>
  );
}
